// extracted by mini-css-extract-plugin
export default {"collapsed":"SurveysTable_collapsed__ZZJiQ","expanded":"SurveysTable_expanded__v4M-d","actions":"SurveysTable_actions__Wu937"};